export default "__VITE_ASSET__CNYyNCok__"